import './checkout-style.css';
import Cookie from 'cookie-universal';
import { giftVoucherOffers } from './offers';
const isEuMember = require('is-eu-member').isEuMember;
const clm = require('country-locale-map');
const cookies = Cookie();

window.DanceMasterclass = window.DanceMasterclass || {};

const savedGeoLocationData = cookies.get('geolocation');
if (savedGeoLocationData && savedGeoLocationData.country_code) {
  // console.log("COOKIE savedGeoLocationData", savedGeoLocationData);
  onGeolocationData(savedGeoLocationData);
} else {
  fetch('https://api.vatcomply.com/geolocate')
    .then((response) => response.json())
    .then((data) => onGeolocationData(data, true))
    .catch((error) => {
      console.error('GeoLocation API Error', error);
    });
}

function onGeolocationData(data, fromApi) {
  // console.log("onGeolocationData", data);
  if (data && data.country_code) {
    if (fromApi) {
      cookies.set('geolocation', data, {
        expires: new Date(new Date().getTime() + 1000 * 3600 * 24 * 7), // a week
      });
    }
    window.DanceMasterclass.country = clm.getCountryByAlpha2(data.country_code);
    window.DanceMasterclass.country.isEuMember = isEuMember(data.country_code);

    handleCheckout();
  }
}

function setFavicons(favImg) {
  const favIconLink = document.querySelector('[rel="shortcut icon"]');

  if (!favIconLink) {
    let headTag = document.querySelector('head');
    let setFavicon = document.createElement('link');

    setFavicon.setAttribute('rel', 'shortcut icon');

    setFavicon.setAttribute('href', favImg);

    headTag.appendChild(setFavicon);
  }
}

setFavicons('https://cdn.dance-masterclass.com/assets/logo-small.webp');

function handleCheckout() {
  if (!document.readyState === 'complete' || !window.jQuery) {
    setTimeout(handleCheckout, 60); // try again
    return;
  }

  const memberName = 'Full Name';
  const memberMail = 'E-Mail Address';
  const memberPassword = 'Create Password';
  const memberPasswordConfirm = 'Confirm Password';
  const memberButtonCaption = 'Complete my purchase';
  const securedWithSSL = 'Secured with SSL';
  const satisfactionGuarnteed = 'Satisfaction Guaranteed';
  const moneyBackGuarantee = '100% Guaranteed';
  const safePayment = 'Safe Payment';

  // Terms and Conditions
  const termsAndConditionsWithSubscription =
    'By clicking "Complete my purchase", you agree to enroll in the chosen subscription plan and accept our <a href="https://www.dance-masterclass.com/terms">Terms and conditions</a>. Cancel any time.';

  const termsAndConditionsWithoutSubscription =
    'By clicking "Complete my purchase", you accept our <a href="https://www.dance-masterclass.com/terms">Terms and conditions</a>.';

  // add font awesome for tick icons
  $('head').append(`
  <script src="https://kit.fontawesome.com/9b0b0edb5f.js" crossorigin="anonymous"></script>
  `);

  // add logo header
  $('.content').prepend(`
    <div class="checkout-header">
      <a class="logo" href="/">
        <img src="https://cdn.dance-masterclass.com/assets/D_Logo_black.webp" alt="Header Logo">
      </a>
    </div>
  `);

  // first payment option (card)
  $('.payment-types-item > label')
    .eq(0)
    .append(
      "<img class='payment-icon' src='https://cdn.dance-masterclass.com/assets/credit%20cards.png'/>",
    );

  // second payment option (paypal)
  $('.payment-types-item > label')
    .eq(1)
    .append(
      "<img class='payment-icon' src='https://cdn.dance-masterclass.com/assets/paypal.png'/>",
    );

  // ssl secure and satisfaction garanteed
  $('.checkout-panel-btn')
    .eq(1)
    .parent()
    .after(
      `<h4 style='margin-top: 2em; font-size: .9em'>🔒 ${securedWithSSL} | ${satisfactionGuarnteed}</h4>`,
    );

  // add money back guarantee panel
  $('.checkout-panel').after(`
    <div class="panel">
        <div class='dmc-row'> 
            <div class="center-content">
                <img class='guarantee-icon' src='https://cdn.dance-masterclass.com/assets/100.png'/>
                <h4 class="padding">${moneyBackGuarantee}</h4>
            </div>
            <div class="center-content ssl-secure">
                <img class='ssl-secure-icon' src='https://cdn.dance-masterclass.com/assets/secure.png'/>
                <h4 class="padding">${safePayment}</h4>
            </div>
        </div>
    </div>
  `);

  // Translate
  $('#checkout_offer_member_name').attr('placeholder', memberName);
  $('#checkout_offer_member_email').attr('placeholder', memberMail);
  $('#checkout_offer_member_password').attr('placeholder', memberPassword);
  $('#checkout_offer_member_password_confirmation').attr(
    'placeholder',
    memberPasswordConfirm,
  );
  $('#checkout_offer_opt_in').parent().remove();

  $("input[name*='commit']").attr('value', memberButtonCaption);

  // Terms and Conditions
  const isWithoutSubscription = giftVoucherOffers.some((id) =>
    window.location.pathname.includes(id),
  );

  if (isWithoutSubscription) {
    console.log('Non subscription base');
    $('.checkout-panel__btn-wrapper').prepend(
      `<p class='dmc-terms-and-conditions'>${termsAndConditionsWithoutSubscription}</p>`,
    );
  } else {
    console.log('Subscription base');
    $('.checkout-panel__btn-wrapper').prepend(
      `<p class='dmc-terms-and-conditions'>${termsAndConditionsWithSubscription}</p>`,
    );
  }

  // Price Breakdown (will be ajax loaded, so we use mutation observer)
  // select the target node
  const priceBreakdownTable = document.querySelector('.checkout-panel');
  let priceBreadownTableAdjusted = false;

  if (priceBreakdownTable) {
    // create an observer instance
    const priceBreakdownObserver = new MutationObserver(function (mutations) {
      if ($('.price-breakdown-table').length) {
        if ($(".price-breakdown-title-generic:contains('Subtotal:')").length) {
          $(".price-breakdown-title-generic:contains('Subtotal:')").html(
            'Subscription',
          );
        }

        if (!priceBreadownTableAdjusted) {
          $('.price-breakdown-table td').each(function () {
            if ($(this).children().length === 0) {
              sanitizeText($(this));
            } else {
              sanitizeText($(this).children('span'));
            }
            priceBreadownTableAdjusted = true;
          });
        }

        // priceBreakdownObserver.disconnect();
      } else {
        // reset the flag if the price breakdown table is removed (e.g. when removing the coupon)
        priceBreadownTableAdjusted = false;
      }
    });

    // configuration of the observer:
    const priceBreakdownConfig = {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    };

    // pass in the target node, as well as the observer options
    priceBreakdownObserver.observe(priceBreakdownTable, priceBreakdownConfig);
  }
}

function sanitizeText(element) {
  let text = element.text();
  text = text.replace(/[.,]0{2}[^0-9€$¥]/g, '');
  text = text.replace('every year', '/year');
  text = text.replace('every month', '/month');
  text = text.replace(' JPY', '');
  text = text.replace('€', '');
  text = text.replace('EUR', '€');
  text = text.replace('USD', '');
  if (element.text() !== text) {
    element.text(text);
  }
}
